<template>
    <div class="partner">
        <div class="header_btn" @keyup.enter="searchBtn">
            <el-input v-model="brandName" class="common_ipt force-style-input" placeholder="请输入品牌名称"
                size="large" clearable />
            <el-button size="large" style="margin:0 0 10px 0;" @click="resetBtn">重置</el-button>
            <el-button type="primary" size="large" style="margin:0 0 10px 10px;" :loading="loading" @click="searchBtn">
                <el-icon class="cancelgu"><Search /></el-icon>搜索
            </el-button>
        </div>

        <div class="summation">
            <div class="hint">统计 : {{ total }}条</div>
        </div>

        <el-table v-loading="loading" class="manage-list-table" :data="tableData" border style="width: 100%"
            :header-cell-style="{ background: '#F5F7FA' }" empty-text="暂无数据">
            <el-table-column label="品牌名称" prop="brandName" min-width="220" align="center" show-overflow-tooltip
                :formatter="formatEmptyValue" />
            <el-table-column label="在售商品（SPU）" prop="onSaleGoodsCount" min-width="220" align="center"
                :formatter="formatEmptyValue" />
        </el-table>

        <el-pagination :hide-on-single-page="true" layout="prev, pager, next,sizes" :page-sizes="[6, 12, 18, 24]"
            :current-page="currentPage" :page-size="pageSize" :total="total" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
    </div>
</template>

<script>
export default {
    name: 'wangyiBrand'
}
</script>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { ElMessage } from 'element-plus';
import { Search } from '@element-plus/icons-vue';
import { queryWangYiBrandList } from '../../../request/api';
import { isRequestErrorHandled } from '../../../request/authExpired';

const brandName = ref('');
const currentPage = ref(1);
const pageSize = ref(6);
const total = ref(0);
const loading = ref(false);
const tableData = ref([]);
let requestVersion = 0;
let disposed = false;

const formatEmptyValue = (row, column, value) => value === null || value === undefined || value === '' ? '-' : value;

const getBrandList = async () => {
    const version = ++requestVersion;
    loading.value = true;
    try {
        const res = await queryWangYiBrandList({
            brandName: brandName.value,
            pageNum: currentPage.value,
            pageSize: pageSize.value
        });
        if (disposed || version !== requestVersion) return;
        if (res.data.code === 0) {
            tableData.value = res.data.data?.data || [];
            total.value = res.data.data?.total || 0;
        } else {
            ElMessage.error(res.data.msg || '品牌列表加载失败，请重试');
        }
    } catch (error) {
        if (!isRequestErrorHandled(error) && !disposed && version === requestVersion) {
            ElMessage.error('品牌列表加载失败，请重试');
        }
    } finally {
        if (!disposed && version === requestVersion) loading.value = false;
    }
};

const searchBtn = () => {
    currentPage.value = 1;
    getBrandList();
};

const resetBtn = () => {
    brandName.value = '';
    currentPage.value = 1;
    pageSize.value = 6;
    getBrandList();
};

const handleSizeChange = (value) => {
    pageSize.value = value;
    currentPage.value = 1;
    getBrandList();
};

const handleCurrentChange = (value) => {
    currentPage.value = value;
    getBrandList();
};

onMounted(getBrandList);
onUnmounted(() => {
    disposed = true;
    requestVersion++;
});
</script>

<style lang="scss" scoped>
.partner {
    height: calc(100vh - 170px);
    width: 95%;
    padding: 20px;
    margin: 15px auto;
    overflow: auto;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: var(--el-box-shadow-light);
}

.header_btn {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;
}

.common_ipt {
    width: 220px;
    margin: 0 10px 10px 0;
}

.force-style-input {
    height: 40px;
    line-height: 40px;
    margin-bottom: 10px;
}

.summation {
    display: flex;
    justify-content: space-between;
}

.hint {
    font-size: 14px;
    color: #909399;
    margin-bottom: 15px;
}

.el-pagination { margin-top: 10px; }

::v-deep .el-table .el-table__cell {
    padding-top: 12px;
    padding-bottom: 12px;
}
</style>
